import { Component, Inject, signal } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { TranslocoCurrencyPipe } from '@jsverse/transloco-locale';

export interface AddToCartDialogData {
  idProdotto: string;
  nomeProdotto: string;
  sku?: string;
  nomeImballo?: string;
  prezzo: number;
  unitaMisura?: string;
}

export interface AddToCartDialogResult {
  quantity: number;
}

@Component({
  selector: 'prd-add-to-cart-dialog',
  imports: [
    MatDialogModule,
    MatButtonModule,
    MatDividerModule,
    TranslocoCurrencyPipe,
  ],
  templateUrl: './add-to-cart-dialog.html',
  styleUrl: './add-to-cart-dialog.scss',
})
export class AddToCartDialog {
  protected quantity = signal(1);

  constructor(
    private dialogRef: MatDialogRef<AddToCartDialog, AddToCartDialogResult>,
    @Inject(MAT_DIALOG_DATA) readonly data: AddToCartDialogData,
  ) {}

  increment() {
    this.quantity.update(q => q + 1);
  }

  decrement() {
    this.quantity.update(q => Math.max(1, q - 1));
  }

  onQuantityInput(value: string) {
    const parsed = parseInt(value, 10);
    this.quantity.set(Number.isNaN(parsed) || parsed < 1 ? 1 : parsed);
  }

  onClose() {
    this.dialogRef.close();
  }

  onConfirm() {
    this.dialogRef.close({ quantity: this.quantity() });
  }
}
